class API {
  static auth = {
    host: 'https://task.foxrenderfarm.com',
    testHost: 'https://task-pre.foxrenderfarm.com',
    downloadHost: 'https://cdl.foxrenderfarm.com',
    queryUser: '/api/rendering/user/queryUser',
    logout: '/api/rendering/user/userLogout',
    agentApply: '/api/rendering/user/agent/agentApply',
    windowsVersion: '/client/desktop/qclient/changelog.php?p=1&os=windows&lang=1',
    linuxVersion: '/client/desktop/qclient/changelog.php?p=1&os=linux&lang=1',
    allVersion: '/client/desktop/qclient/client_version_log.php?p=1&os=all&lang=1',
    uploadScreenshot: '/api/rendering/user/feedback/uploadScreenshot',
    addFeedback: '/api/rendering/user/feedback/frontUserFeedback',
    queryQuestionnaire: '/api/rendering/user/productResearch/questionnaire',
    submitQuestionnaire: '/api/rendering/user/productResearch/questionnaireResult',
  }
}

export default API
